// Wire shape from GET .../notes: the proxy strips the raw note's numeric user_id and injects a `user` object hydrated from the customers service.
type CampaignNoteUserFromServer = {
  id: number
  first_name: string
  last_name: string
  email: string
}

type CampaignNoteFromServer = {
  id: number
  campaign_id: number
  note: string
  created_at: string
  user?: CampaignNoteUserFromServer
}

// OpenAPI `NoteCreateRequest` for POST /campaigns/:id/notes.
type NoteCreateRequest = {
  note: string
  user_id: number
}

export type CampaignNoteUser = {
  id: number
  firstName: string
  lastName: string
  email: string
}

export type CampaignNote = {
  id: number
  text: string
  user: CampaignNoteUser
  createdAt: string
}

const noteUserFromServer = (x?: CampaignNoteUserFromServer): CampaignNoteUser =>
  x
    ? { id: x.id, firstName: x.first_name, lastName: x.last_name, email: x.email }
    : { id: 0, firstName: '', lastName: '', email: '' }

export const campaignNoteFromServer = (x?: CampaignNoteFromServer): CampaignNote =>
  x
    ? {
        id: x.id,
        text: x.note,
        user: noteUserFromServer(x.user),
        createdAt: x.created_at,
      }
    : { id: 0, text: '', user: noteUserFromServer(), createdAt: '' }

export const campaignNoteToServer = (x: any): NoteCreateRequest => ({
  user_id: x.userId,
  note: x.note,
})
